import Vue from 'vue'
import { ProgressLoader, SnackBar } from '@ciitizen/component-library'

// register each component
Vue.component('progress-loader', ProgressLoader)
Vue.component('snack-bar', SnackBar)
